export default __webpack_public_path__ + "static/media/dipLogoEntrepriseW.4cb0a1af.webp";